module.exports = __webpack_public_path__ + "img/trophy.584cec5a.svg";